module.exports = __webpack_public_path__ + "fonts/dk-carambola.0633e4e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/peekaboo/fonts/dk-carambola.woff
// module id = 394
// module chunks = 0